// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__DTNaa","infoBtn":"quickbooks_infoBtn__2PfET","formBox":"quickbooks_formBox__3o-u1","formFooter":"quickbooks_formFooter__hU8Tq"};